import { initAll } from "@nationalarchives/frontend/nationalarchives/all.mjs";

initAll();
